import getNewsletterInfo from '../helpers/newsletters'
import { Newsletter } from '../types'
import useTranslations from './useTranslations'

export default function useNewsletter(
  newsletter: Newsletter | null | undefined,
  params?: { forHtml?: boolean; fullQualifiedUrl?: boolean },
) {
  const $t = useTranslations()

  return getNewsletterInfo(newsletter, $t, params)
}
